import * as React from "react"
import { CardModal, CardModalType } from "../modal"
import { getFullName, getProfileLabel, Profile, getProfile } from "../../domain/sfp/user-domain"
import { Title, User, LocalAuthority, Service, ServiceGroup } from "../../model"
import { getCodeName, getLocalAuthority } from "../../domain/sfp/local-authority-domain"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { NotificationProps } from "../notification"


export default class UserDetailModalComponent
extends React.Component<UserDetailModalComponentProps> {
	render() {
		const submitting = this.props.submitting
		const loading = this.props.loadingServices || submitting || this.props.loadingChildLA ||this.props.lodingChildServices || this.props.loadingChildGroups
		const selectedProfile = this.props.selectedProfile
		const user = this.props.user
		const title = user ? `${getFullName(user)}` : "Ajouter un utilisateur"
		const disabled = (selectedProfile === Profile.ServiceAgent && !this.props.serviceChecked)

		return <CardModal
		active={true}
		loading={loading}
		title={title}
		type={CardModalType.ValidCancel}
		disabled={disabled}
		onClickCloseButton={this.props.onClose}
		onClickFooterButton={(b, e) => this.props.onClose(e)}
		onClickNotificationCloseButton={e => this.props.onClickNotificationCloseButton(e)}
		notification={this.props.notification}
		onSubmit={this.props.onSubmit}>
			{/* Title */}
			<div className="field">
				<label className="label" htmlFor={Ids.Title}>Civilité</label>
				<div className="control">
					<div className={`select is-fullwidth${submitting ? " is-loading" : ""}`}>
						<select
						defaultValue={user ? String(user.title) : ""}
						disabled={submitting}
						id={Ids.Title}
						name={Names.Title}
						required>
							<option disabled value="">Sélectionner une civilité</option>
							{this.props.titles.map((title, i) =>
							<option key={i} value={title.id}>{title.longLabel}</option>)}
						</select>
					</div>
				</div>
			</div>

			{/* First name */}
			<div className="field">
				<label className="label" htmlFor={Ids.FirstName}>Prénom</label>
				<div className={`control${submitting ? " is-loading" : ""}`}>
					<input
					className="input"
					defaultValue={user && user.firstName}
					disabled={submitting}
					id={Ids.FirstName}
					name={Names.FirstName}
					placeholder="François"
					required
					type="text" />
				</div>
			</div>

			{/* Last name */}
			<div className="field">
				<label className="label" htmlFor={Ids.LastName}>Nom</label>
				<div className={`control${submitting ? " is-loading" : ""}`}>
					<input
					className="input"
					defaultValue={user && user.lastName}
					disabled={submitting}
					id={Ids.LastName}
					name={Names.LastName}
					placeholder="Gernigon"
					required
					type="text" />
				</div>
			</div>

			{/* E-mail */}
			<div className="field">
				<label className="label" htmlFor={Ids.Email}>Adresse e-mail</label>
				<div className={`control${submitting ? " is-loading" : ""}`}>
					<input
					className="input"
					defaultValue={user && user.email}
					disabled={submitting}
					id={Ids.Email}
					name={Names.Email}
					placeholder="f.g@email.fr"
					required
					type="email" />
				</div>
			</div>

			{/* Phone */}
			<div className="field">
				<label className="label" htmlFor={Ids.Phone}>Téléphone</label>
				<div className={`control${submitting ? " is-loading" : ""}`}>
					<input
					className="input"
					defaultValue={user && user.phone1}
					disabled={submitting}
					id={Ids.Phone}
					name={Names.Phone}
					pattern="[0-9]{10}"
					placeholder="0123456789"
					type="tel" />
				</div>
			</div>

			{/* Profile */}
			<div className="field">
				<label className="label" htmlFor={Ids.Profile}>Profil</label>
				{1 === this.props.profiles.length
				? <div className={`control${submitting ? " is-loading" : ""}`}>
						<input className="input is-static" readOnly type="text" value={getProfileLabel(this.props.profiles[0])} />
						<input name={Names.Profile} readOnly type="hidden" value={this.props.profiles[0]} />
					</div>
				: <div className="control">
						<div className={`select is-fullwidth${submitting ? " is-loading" : ""}`}>
							<select
							disabled={submitting}
							id={Ids.Profile}
							name={Names.Profile}
							onChange={this.props.onProfileChange}
							value={null !== selectedProfile ? selectedProfile : ""}
							required>
								<option disabled value="">Sélectionner un profil</option>
								{this.props.profiles.map((profile, i) =>
								<option key={i} value={profile}>{getProfileLabel(profile)}</option>)}
							</select>
						</div>
					</div>}
			</div>
			{this.getProfileFormFields(this.props)}
		</CardModal>
	}

	private getProfileFormFields(props: UserDetailModalComponentProps): React.ReactNode {
		switch (props.selectedProfile) {
			case Profile.RegionAdmin:
				return this.getRegionFormField(props)
			case Profile.LocalAuthorityAdmin:
			case Profile.LocalAuthorityConsultant:
				return this.getLocalAuthorityFormField(props)
			case Profile.ServiceAgent:
				return this.getServicesFormFields(props)
			case Profile.Adminbudgetannexe:
				return  this.budgetAnnexe(props)
			case Profile.Consultantbudgeannexe:
				return this.budgetAnnexe(props)
			default:
				return null
		}
	}

	private getLocalAuthorityFormField(
		props: UserDetailModalComponentProps,
		key: number | null = null
	): React.ReactNode {
		const currentUser = props.currentUser
		const localAuthorities = props.localAuthorities
		const selectedLocalAuthority = props.selectedLocalAuthority
		const services = props.services

		const collectivityBar=<div className="control">
		<div className={`select is-fullwidth${props.submitting ? " is-loading" : ""}`}>
			<select
			id={Ids.LocalAuthority}
			name={Names.LocalAuthority}
			value={selectedLocalAuthority ? selectedLocalAuthority.id : ""}
			onChange={props.onLocalAuthorityChange}
			required>
				<option disabled value="">Sélectionner une collectivité</option>
				{localAuthorities.map((la, i) =>
				<option key={i} value={la.id}>{getCodeName(la)}</option>)}
			</select>
		</div>
	</div>	

		let localAuthorityContent: React.ReactNode

		switch (getProfile(currentUser)) {
			case Profile.LocalAuthorityAdmin:
				const managedLocalAuthority = localAuthorities.find(la => la.id === currentUser.managedLocalAuthority)
				localAuthorityContent = <div className="control">
					<input className="input is-static" readOnly type="text" value={getCodeName(managedLocalAuthority)} />
					<input name={Names.LocalAuthority} readOnly type="hidden" value={currentUser.managedLocalAuthority} />
				</div>
				break
			case Profile.LocalAuthorityConsultant:
				const consultedLocalAuthority = localAuthorities.find(la => la.id === currentUser.consultedLocalAuthority)
				localAuthorityContent = <div className="control">
					<input className="input is-static" readOnly type="text" value={getCodeName(consultedLocalAuthority)} />
					<input name={Names.LocalAuthority} readOnly type="hidden" value={currentUser.consultedLocalAuthority} />
				</div>
				break
			case Profile.ServiceAgent:
				const localAuthority = getLocalAuthority(localAuthorities, services[0].localAuthority)
				localAuthorityContent = <div className="control">
					<input className="input is-static" readOnly type="text" value={getCodeName(localAuthority)} />
					<input name={Names.LocalAuthority} readOnly type="hidden" value={localAuthority.id} />
				</div>
				break
			case Profile.Adminbudgetannexe:	
			    localAuthorityContent = collectivityBar			
			break
			case Profile.Consultantbudgeannexe:	
			    localAuthorityContent = collectivityBar			
		    break
			default:
				localAuthorityContent = collectivityBar
				
				break
		}

		return <div className="field" key={key}>
			<label className="label" htmlFor={Ids.LocalAuthority}>Collectivité</label>
			{1 === localAuthorities.length
			? <div className={`control${props.submitting ? " is-loading" : ""}`}>
				<input className="input is-static" readOnly type="text" value={getCodeName(localAuthorities[0])} />
				<input name={Names.LocalAuthority} readOnly type="hidden" value={localAuthorities[0].id} />
			</div>
			: localAuthorityContent}
		</div>
	}

	/* child LocalAthorities */
	private childLA(props:any){
		const localAuthorities = props.childrenLA
	  return	[<div className="control">
		  {localAuthorities.map(res=>
		  {const isSelected = props.idsChildrenLA.find(id => id === res.id)
		return  [<div className="field" key={res.id}>
			<label className="label" >{res.name}</label>
			<ul className="menu-list" >	 
				<li className="control" >
					<label className="checkbox">
						<input  type="checkbox" checked={isSelected !== undefined} onChange={()=>props.onClickChildrenServices("Oui",res)}/>
						&nbsp;Oui
					</label>
				</li>
				<li className="control" >
					<label className="checkbox">
						<input  type="checkbox" checked={isSelected === undefined} onChange={()=>props.onClickChildrenServices("Non",res)}/>
							&nbsp;Non
					</label>
				</li>
			</ul>
			</div>,
			/*services related to child LocalAthorities */
		this.getServicesFormFieldChild(props, 1,res)]})}
		</div>]	
	}

	private getRegionFormField(props: UserDetailModalComponentProps): React.ReactNode {
		return <div className="field">
			<label className="label" htmlFor={Ids.Region}>Région</label>
			<div className="control">
				<div className={`select is-fullwidth${props.submitting ? " is-loading" : ""}`}>
					<select 
					name={Names.Region}
					id={Ids.Region}
					value={this.props.selectedRegionId ? this.props.selectedRegionId : ""}
					onChange={props.selectedRegionIdChange}
					required>
				<option disabled value="">Sélectionner une Région</option>
				{this.props.regions.map((r, i) =>
				<option key={i} value={r.id}>{r.name}</option>)}
					</select>
				</div>
			</div>
		</div>
	}
	
	private budgetAnnexeChid(
		props: UserDetailModalComponentProps,
		key: number | null = null
	): React.ReactNode {

		const localAuthorities = props.childrenLA

		return <div className="field" >
				{props.loadingServices || props.loadingGroups
				? <div className="control is-loading">
						<input className="input is-static" readOnly value="Chargement des services..." />
					</div>
				: !localAuthorities.length
					? <div className="control">
							<input className="input is-static" readOnly value="Aucun Budget Annexe" />
						</div>
					:[<label className="label">Budget Annexe</label>,
		            <aside className="menu">
			        {localAuthorities.map(res=>{
					let check=props.budgetanex.find(id=> id === res.id)
					return( 
					<ul className="menu-list">
					    <li className="control" >
			                <label className="checkbox">
				            <input disabled={props.submitting} checked={check === res.id} type="checkbox" name={Names.Childbudget} value={res.name} onChange={e => this.props.onChangeBudget(res, e)}/>
				            &nbsp;{res.name}
			                </label>
		                </li>
				</ul>)})}
	         </aside>]}
	</div>	
	}

	/*services related to child LocalAthorities */
	private getServicesFormFieldChild(
		props: UserDetailModalComponentProps,
		key: number | null = null,
		res:any
	): React.ReactNode {
		const services:any = props.childServices
		const groups = props.childGroups
		const groupServicesChild = props.groupServicesChild
		const submitting = props.submitting
		const idsGroup = props.idsGroupChild
		const userServices = props.userServicesChlidren
		const localAuthorities = props.localAuthorities
		const sizeIcon = "sm"
		const idsChildrenLA = props.idsChildrenLA
		const isSelected = idsChildrenLA.find(id => id === res.id)
		const childService = isSelected ? props.childrenLA.find(la => la.id === res.id) : null
		let noServices=true
		
		if(childService){
		return <div className="field" style={{marginLeft:'55px'}} key={key}>
			<label className="label">Services</label>
				<aside className="menu">
			<ul className="menu-list">
						{/* list of group with services in child */}
						{groups && groups.length
						? groups.map((group, i) => {
							// if only 1 one item is present
							// or if user exists and has one service with the same id
							// check it
							let check=idsGroup.find(id=> id === group.id)
							if(group.localAuthority == res.id){
								noServices=false
							return <li className="control" key={i}>
								<label className="checkbox">
									<input  disabled={submitting}  checked={check === group.id} type="checkbox" value={group.id} onChange={e => this.props.onChangeGroupChid(group, e)}/>
									&nbsp;
									<FontAwesomeIcon icon={"folder"} size={sizeIcon} />
									&nbsp;{group.label}
								</label>
							{/* list of services, child of group */}
							{groups && group.services.length
								&& <ul>
									{groupServicesChild.map((service, i) => {  
										let check=props.finalChildService.find(id=> id === service.id) 
										let index=group.services.indexOf(service.id)
										if(index !== -1){
											return (
												<li key={i} className="control">
													<label className="checkbox">
														<input type="checkbox" checked={check === service.id} value={service.id} onChange={e => this.props.onChildChangeService(service, e)}/>
														&nbsp;
														<FontAwesomeIcon icon={"file-alt"} size={sizeIcon} />
														&nbsp;{service.label}
													</label>
												</li>)	
										}          	
										})}
									</ul>}
								</li>
						}})
					: ""}
						{/* rest of services that does not have parent group */}
						{services.length > 0 && services &&
						services.map((service, i) => {  
							if (service && !service.serviceGroup && res.id == service.localAuthority) {
								let check=props.finalChildService.find(id=> id === service.id)
								noServices=false
								return <li key={i} className="control">
									<label className="checkbox">
										<input   type="checkbox" checked={check === service.id} value={service.slug} onChange={e => this.props.onChildChangeService(service, e)}/>
										&nbsp;
										<FontAwesomeIcon icon={"file-alt"} size={sizeIcon} />
										&nbsp;{service.label}
									</label>
								</li>
							}
						})
				        }
						{!props.lodingChildServices && noServices&&<span>Aucun service enregistré</span>}
					</ul>
			</aside>
		</div>
		}}

		private getServicesFormField(
			props: UserDetailModalComponentProps,
			key: number | null = null
		): React.ReactNode {
			const services = props.services
			const groups = props.groups
			const submitting = props.submitting
			const idsGroup = props.idsGroup
			const userServices = props.userServices
			const localAuthorities = props.localAuthorities
			const sizeIcon = "sm"
			return [<div className="field" key={key}>
					<label className="label">Services</label>
					<aside className="menu">
					{props.loadingServices || props.loadingGroups
					? <div className="control is-loading">
							<input className="input is-static" readOnly value="Chargement des services..." />
						</div>
					: (!services.length
						? <div className="control">
								<input className="input is-static" readOnly value="Aucun service disponible" />
							</div>
						: <ul className="menu-list">
							{/* list of group with services in child */}
							{groups && groups.length
							? groups.map((group, i) => {
								const checkedGrp = idsGroup.some(grpId => grpId === group.id)
								// if only 1 one item is present
								// or if user exists and has one service with the same id
								// check it
								return <li className="control" key={i}>
									<label className="checkbox">
										<input disabled={submitting} checked={checkedGrp} name={Names.Groups} type="checkbox" value={group.id} onChange={e => this.props.onChangeGroup(group, e)}/>
										&nbsp;
										<FontAwesomeIcon icon={"folder"} size={sizeIcon} />
										&nbsp;{group.label}
									</label>
								{/* list of services, child of group */}
								{services && services.length
									? <ul>
											{group.services.map((serviceId, i) => {
												const service = services.find(srvc => srvc.id === serviceId)
												// const checkedSrv = userServices.some(s => s.id === serviceId)
	
												const checked = userServices.find(({ id }) => serviceId === id);
	
													if (service) {
														return (<li key={i} className="control">
																<label className="checkbox">
																	<input checked={checked && checked.slug === service.slug} disabled={submitting} name={Names.Services} type="checkbox" value={service.slug} onChange={e => this.props.onChangeService(service, e)}/>
																	&nbsp;
																	<FontAwesomeIcon icon={"file-alt"} size={sizeIcon} />
																	&nbsp;{service.label}
																</label>
														</li>)
													}
											})}
										</ul>
									: <span>Aucun service enregistré</span>}
									</li>
							})
						: ""}
							{/* rest of services that does not have parent group */}
							{services.map((service, i) => {
								const checkedSrv = userServices.some(s => s.id === service.id)
								if (service && !service.serviceGroup) {
									return <li key={i} className="control">
										<label className="checkbox">
											<input checked={checkedSrv} disabled={submitting} name={Names.Services} type="checkbox" value={service.slug} onChange={e => this.props.onChangeService(service, e)}/>
											&nbsp;
											<FontAwesomeIcon icon={"file-alt"} size={sizeIcon} />
											&nbsp;{service.label}
										</label>
									</li>
								}
							})
							}
						</ul>
					)}
				</aside>
			</div>,
			props.childrenLA && props.childrenLA.length > 0 && 
			 <label className="label" htmlFor={Ids.LocalAuthority}>Gestionnaire d'un budget annexe ?</label>
			 ,props.childrenLA && props.childrenLA.length > 0 &&<ul className="menu-list">
				 {['Oui','Non'].map((res,index)=>
				  <li className="control" key={index}>
								<label className="checkbox">
									<input  type="checkbox" checked={res == props.showCollectivites} onChange={e => this.props.onChangeCollectivite(res,e)}/>
									&nbsp;{res}
								</label>
						</li>)}
			</ul> 
			,props.showCollectivites === 'Oui' && props.finalChildService.length <= 0 && props.childServicesError && <span style={{color:'red'}}>Must select one child services</span>
			,this.props.showCollectivites === 'Non' ?'':this.childLA(props)]
	
		}

	private getServicesFormFields(props: UserDetailModalComponentProps): React.ReactNode {
		return [
			this.getLocalAuthorityFormField(props, 0),
			this.getServicesFormField(props, 1)
		]
	}

	private budgetAnnexe(props: UserDetailModalComponentProps): React.ReactNode {
		return [
			this.getLocalAuthorityFormField(props, 0),
			this.budgetAnnexeChid(props, 1)
		]
	}

}

export enum Names {
	Email = "email",
	FirstName = "firstName",
	Groups = "groups",
	LastName = "lastName",
	LocalAuthority = "localAuthority",
	Phone = "phone",
	Profile = "profile",
	Region = "region",
	Services = "services",
	Title = "title",
	Childbudget = 'Childbudget'
}

export interface UserDetailModalComponentProps {
	currentUser: User
	loadingGroups: boolean
	loadingChildGroups:boolean
	loadingServices: boolean
	lodingChildServices:boolean
	localAuthorities: LocalAuthority[]
	slectedChildLA: LocalAuthority
	idsGroup: number[]
	userServices: Service[]
	userServicesChlidren:Service[]
	groups: ServiceGroup[]
	childGroups: ServiceGroup[]
	profiles: Profile[]
	selectedLocalAuthority: LocalAuthority
	selectedProfile: Profile
	services: Service[]
	childServices: Service[]
	submitting: boolean
	titles: Title[]
	user?: User
	showCollectivites:any
	childrenLA:LocalAuthority[]
	idsChildrenLA:number[]
	loadingChildLA:boolean
	childServicesError:boolean
	finalChildService:number[]
	budgetanex:Number[]
	groupServicesChild:Service[]
	idsGroupChild:number[]
	regions:any
	selectedRegionId:number
	serviceChecked: boolean
	notification?: NotificationProps
	onClose(e: React.SyntheticEvent<Element>): void
	onChangeGroup(group: ServiceGroup, e: React.SyntheticEvent<Element>): void
	onChangeGroupChid(group: ServiceGroup, e: React.SyntheticEvent<Element>): void
	onChangeService(service: Service, e: React.SyntheticEvent<Element>): void
	onChildChangeService(service: Service, e: React.SyntheticEvent<Element>): void
	onChangeBudget(res: any, e: React.SyntheticEvent<Element>): void
	onLocalAuthorityChange(e: React.SyntheticEvent<Element>): void
	selectedRegionIdChange(e: React.SyntheticEvent<Element>): void
	onProfileChange(e: React.SyntheticEvent<Element>): void
	onSubmit(e: React.SyntheticEvent<Element>): void
	onChangeCollectivite(res:any,e:React.SyntheticEvent<Element>): void
	onClickChildrenServices(res1:any,res:any):void
	onClickNotificationCloseButton(e: React.SyntheticEvent<Element>): void
}

enum Ids {
	Email = "user-detail-email",
	FirstName = "user-detail-first-name",
	LastName = "user-detail-last-name",
	LocalAuthority = "user-detail-local-authority",
	Phone = "user-detail-phone",
	Profile = "user-detail-profile",
	Region = "user-detail-region",
	Title = "user-detail-title"
}



// WEBPACK FOOTER //
// ./src/component/user-detail-modal/user-detail-modal-component.tsx